import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import KnowYourRole from './knowYourRole';
import LeftArrow from "../../../../Images/red-arrow.png";
import { useLocation, useNavigate } from "react-router-dom";
import Stars from './Star/stars';
import ContentLibrary from './ContentLibrary/contentLibrary';
import ProductUpdatesAdmin from './productUpdates';
import TrainingModule from './trainingModule';
import BusinessUnderstanding from './businessUnderstanding';
import PageBreadcrumb from '../../../../reusableField/PageBreadcrumb';
import { Role_Account_Query } from '../../../../services/userAPI';
import { useQuery } from '@apollo/client';
import HomeIcon from "../../../../Images/homeIcon.png";
import BackIcon from "../../../../Images/backIcon.png";

const KnowYourTabs = () => {
    const { TabPane } = Tabs;
    const location = useLocation();
    const getTabFromPath = (path) => {
        if (path.includes('stars')) return '2';
        if (path.includes('content-library')) return '3';
        if (path.includes('business-understanding')) return '4';
        if (path.includes('product-updates')) return '4';
        if (path.includes('training')) return '5';
        return '1';
    };

    const [activeTab, setActiveTab] = useState(getTabFromPath(location.pathname));

    useEffect(() => {
        setActiveTab(getTabFromPath(location.pathname));
    }, [location.pathname]);

    // useEffect(() => {
    //     if (location.state?.activeTab) {
    //         setActiveTab(location.state.activeTab);
    //     }
    // }, [location.state?.activeTab]);

    const handleTabChange = (key) => {
        setActiveTab(key);
        const pathMap = {
            '1': '/clan-management',
            '2': '/clan-management/stars',
            '3': '/clan-management/content-library',
            '4': '/clan-management/business-understanding',
            '5': '/clan-management/training',
        };
        navigate(pathMap[key], { state: { ...currentState } });
    };



    const navigate = useNavigate();
    const currentPath = location.pathname;
    const currentState = location.state || {};
    const name = currentState?.name;
    const accountName = currentState?.accountName;

    const safeAccountName = accountName || '';



    const handleTopNavigation = (path, tabKey) => {
        const newState = {
            ...currentState,
            activeTab: tabKey || currentState?.activeTab || '1',
        };

        if (currentPath === path) {
            setActiveTab(newState.activeTab);
            navigate(path, { state: newState, replace: true });
            return;
        }

        navigate(path, { state: newState });
    };

    const dartsFormNeeded = location.state?.dartsFormNeeded;
    const pocName = location.state?.pocName;
    const pocEmail = location.state?.pocEmail;
    const pocNumber = location.state?.pocNumber;
    const numberLogin = location.state?.numberLogin;
    const emailLogin = location.state?.emailLogin;
    const mandatoryTimeDistribution = location.state?.mandatoryTimeDistribution;
    const targetEditDays = location.state?.targetEditDays;
    const inputEditDays = location.state?.inputEditDays;
    const dartsNeeded = location.state?.dartsNeeded;
    const clanNeeded = location.state?.clanNeeded;
    const syncNeeded = location.state?.syncNeeded;
    const roleId = location.state?.roleId;
    const accountId = location.state?.accountId;
    const safeAccountId = accountId;
    const [inputType, setInputType] = useState(null);

    const { data: roleData } = useQuery(Role_Account_Query, {
        variables: { accountId: accountId ? parseInt(accountId) : null },
        fetchPolicy: "network-only",
        skip: !accountId,
    });

    const currentRole = roleData?.getAllJobrole?.find((r) => r.id === roleId);
    const safeRoleName = name || currentRole?.name || "";

    const handleBackToViewRole = () => {
        navigate("/productsConfiguration", {
            state: {
                roleId: roleId || location.state?.roleId,
                accountId: accountId || location.state?.accountId,
                accountName: accountName || location.state?.accountName,
                name: name || location.state?.name,
                dartsNeeded: inputType ? true : dartsNeeded || location.state?.dartsNeeded, // Update based on inputType
                clanNeeded: clanNeeded || location.state?.clanNeeded,
                syncNeeded: syncNeeded || location.state?.syncNeeded,
                dartsFormNeeded: inputType === "Forms" || dartsFormNeeded || location.state?.dartsFormNeeded,
                pocName: pocName || location.state?.pocName,
                pocEmail: pocEmail || location.state?.pocEmail,
                pocNumber: pocNumber || location.state?.pocNumber,
                numberLogin: numberLogin || location.state?.numberLogin,
                emailLogin: emailLogin || location.state?.emailLogin,
                mandatoryTimeDistribution: mandatoryTimeDistribution || location.state?.mandatoryTimeDistribution,
                targetEditDays: targetEditDays || location.state?.targetEditDays,
                inputEditDays: inputEditDays || location.state?.inputEditDays,
            },
        });
    };

    return (
        <div className="user-profile-container know-your-tabs-page" style={{ paddingTop: 105, paddingBottom: 32, marginTop: 0 }}>
            <div className=" mx-auto px-3">
                <div className="flex justify-between items-center w-full  mx-2">

                    {/* Back Button */}
                    <button
                        onClick={handleBackToViewRole}
                        className="flex items-center gap-2 bg-[#C21A17] text-white px-5 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-[#A91513] transition-all duration-200"
                    >
                        <img
                            src={BackIcon}
                            alt="Back"
                            className="w-[15px] h-[15px] object-contain"
                        />
                        Back
                    </button>

                    {/* Home Button */}
                    <button
                        onClick={() => navigate("/admin")}
                        className="flex items-center gap-2 bg-[#C21A17] text-white px-5 py-2 mr-4 rounded-lg text-sm font-semibold shadow-md hover:bg-[#A91513] transition-all duration-200"
                    >
                        <img
                            src={HomeIcon}
                            alt="Home"
                            className="w-[15px] h-[15px] object-contain"
                        />
                        Home
                    </button>

                </div>
                <div
                    className="flex items-center text-sm text-[#939393]"
                    style={{ marginTop: 12, marginLeft: 11 }}
                >
                    <span
                        onClick={() => navigate("/admin")}
                        className="cursor-pointer"
                    >
                        {safeAccountName}
                    </span>

                    <span className="mx-2 text-[14px]">
                        ›
                    </span>

                    <span
                        onClick={() =>
                            navigate("/dashboard", {
                                state: {
                                    roleId,
                                    accountId,
                                    name,
                                    accountName,
                                },
                            })
                        }
                        className="cursor-pointer"
                    >
                        {safeRoleName}
                    </span>

                    <span className="mx-2 text-[14px]">
                        ›
                    </span>

                    {/* Experience Configuration */}
                    <span
                        onClick={() =>
                            navigate("/experience-configuration", {
                                state: {
                                    roleId,
                                    accountId,
                                    name,
                                    accountName,
                                },
                            })
                        }
                        className="cursor-pointer"
                    >
                        Experience Configuration
                    </span>

                    <span className="mx-2 text-[14px]">
                        ›
                    </span>

                    {/* Product Configuration */}
                    <span
                        onClick={() =>
                            navigate("/productsConfiguration", {
                                state: {
                                    roleId,
                                    accountId,
                                    name,
                                    accountName,
                                },
                            })
                        }
                        className="cursor-pointer"
                    >
                        Product Configuration
                    </span>

                    <span className="mx-2 text-[14px]">
                        ›
                    </span>

                    <span className="font-semibold text-gray-800">
                        Clan
                    </span>
                </div>
            </div>


            <div className="w-full flex justify-center mt-[25px] mb-[15px]">
                <div className="flex items-center gap-3 p-1.5 bg-white border border-gray-300 rounded-2xl shadow-sm">

                    <button
                        onClick={() =>
                            navigate("/products-Configuration", {
                                state: { ...location.state },
                            })
                        }
                        className={`px-5 py-1 rounded-lg text-base font-semibold ${currentPath === "/products-Configuration"
                            ? "bg-red-50 text-red-600"
                            : "text-gray-500"
                            }`}
                    >
                        Darts
                    </button>

                    <button
                        onClick={() =>
                            navigate("/faqs", {
                                state: { ...location.state },
                            })
                        }
                        className={`px-5 py-1 rounded-lg text-base font-semibold ${currentPath === "/faqs"
                            ? "bg-red-50 text-red-600"
                            : "text-gray-500"
                            }`}
                    >
                        FAQ's
                    </button>

                    <button
                        onClick={() =>
                            navigate("/clan-management", {
                                state: {
                                    ...location.state,
                                    activeTab: "3",
                                },
                            })
                        }
                        className={`px-5 py-1 rounded-lg text-base font-semibold ${currentPath === "/clan-management" || currentPath === "/clan-management/stars" || currentPath === "/clan-management/content-library" || currentPath === "/clan-management/business-understanding" || currentPath === "/clan-management/product-updates"
                            ? "bg-red-50 text-red-600"
                            : "text-gray-500"
                            }`}
                    >
                        Content
                    </button>

                </div>
            </div>

            <Tabs

                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', marginTop: '8px' }}
                activeKey={activeTab}
                onChange={handleTabChange}

            >
                <TabPane
                    tab={<span style={{ color: activeTab === '1' ? '#d32f2f' : 'inherit', paddingBottom: '8px', fontFamily: "Inter", fontWeight: "500", width: '100%', borderBottom: activeTab === '1' ? '2px solid #d32f2f' : 'none', }}>
                        Know Your Role
                    </span>}
                    key="1"
                >
                    <div style={{ paddingTop: 16 }}><KnowYourRole /></div>
                </TabPane>
                <TabPane
                    tab={<span style={{ color: activeTab === '2' ? '#d32f2f' : 'inherit', paddingBottom: '8px', fontFamily: "Inter", fontWeight: "500", borderBottom: activeTab === '2' ? '2px solid #d32f2f' : 'none' }}>
                        Stars
                    </span >}
                    key="2"
                >
                    <div style={{ paddingTop: 16 }}><Stars /></div>
                </TabPane >
                <TabPane
                    tab={<span style={{ color: activeTab === '3' ? '#d32f2f' : 'inherit', paddingBottom: '8px', fontFamily: "Inter", fontWeight: "500", borderBottom: activeTab === '3' ? '2px solid #d32f2f' : 'none', }}>
                        Content Library
                    </span >}
                    key="3"
                >
                    <div style={{ paddingTop: 16 }}><ContentLibrary /></div>
                </TabPane >
                <TabPane
                    tab={<span style={{ color: activeTab === '4' ? '#d32f2f' : 'inherit', paddingBottom: '8px', fontFamily: "Inter", fontWeight: "500", borderBottom: activeTab === '4' ? '2px solid #d32f2f' : 'none', }}>
                        Business Understanding 
                    </span >}
                    key="4"
                >
                    <div style={{ paddingTop: 16 }}><BusinessUnderstanding /></div>
                </TabPane >
                <TabPane
                    tab={<span style={{ color: activeTab === '5' ? '#d32f2f' : 'inherit', paddingBottom: '8px', fontFamily: "Inter", fontWeight: "500", borderBottom: activeTab === '5' ? '2px solid #d32f2f' : 'none', }}>
                        Training Modules
                    </span >}
                    key="5"
                >
                    <div style={{ paddingTop: 16 }}><TrainingModule /></div>
                </TabPane >
            </Tabs >
        </div >
    );
};

export default KnowYourTabs;